import { VOMedia, VOMediaType } from "../model/DataStructure.js";
import { Icon } from "./Icon.js";
import { MediaContent } from "./MediaContent.js";
import { MediaGallery } from "./MediaGallery.js";
import { MediaIFrame } from "./MediaIFrame.js";
import { MediaImage } from "./MediaImage.js";
import { MediaVideo } from "./MediaVideo.js";
import { PageIndicator } from "./PageIndicator.js";
import { VideoControl } from "./VideoControl.js";

export interface MediaOptions {
    container: HTMLElement;
    visible?: boolean;
    layout?: "intrinsic" | "cover";
}

export class Media {

    private _element: HTMLDivElement;
    private _options: MediaOptions;
    private _contents: MediaContent[] = [];

    constructor(options: MediaOptions) {
        options = e5.object.merge({
            visible: false,
            layout: "cover"
        }, options);
        this._options = options;

        this._element = document.createElement("div");
        this._element.className = "media media--layout-" + options.layout;
        this._element.innerHTML = ``;

        this._contents = [
            new MediaVideo({
                container: this._element
            }),
            new MediaImage({
                container: this._element
            }),
            new MediaGallery({
                container: this._element
            }),
            new MediaIFrame({
                container: this._element
            })
        ];

        this.visible = options.visible;

        options.container.appendChild(this._element);
    }

    private _timeout:any = null;
    public load(data: VOMedia): void {
        clearTimeout(this._timeout);
        
        for(let c of this._contents){
            c.visible = false;
        }

        this._timeout = setTimeout(() => {
            for(let c of this._contents){
                if(c.type === data.type){
                    c.prepare(data);
                    c.load(data);
                    c.visible = true;
                    break;
                }
            }
        }, 300);        
    }

    public get visible(): boolean {
        return !this._element.classList.contains("media--hidden");
    }

    public set visible(value: boolean) {
        this._element.classList.toggle("media--hidden", !value);

        if(!value){
            for(let c of this._contents){
                c.visible = false;         
            }
        }
    }
}